import React, { useState } from "react";
import { MdShoppingBasket, MdAdd, MdLogout, MdLogin } from "react-icons/md";
import { motion } from "framer-motion";
import Logo from "../assets/img/logo.png";
import Avatar from "../assets/img/avatar.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { app } from "../config/firebase.config";
import { getAuth } from "firebase/auth";
import { setUserNull } from "../context/actions/userActions";
import CartContainer from "../containers/CartContainer";
import { openCart } from "../context/actions/cartActions";

const Header = () => {
    const handleGoToMenu = () => {
        const menuSection = document.getElementById('menu');
        if (menuSection) {
            menuSection.scrollIntoView({ behavior: 'smooth' });
        }
    };
    const isCartOpen = useSelector((state) => state.cart.isCartOpen);

    const firebaseAuth = getAuth(app);
    const cartItems = useSelector(state => state.cart);
    const user = useSelector(state => state.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const handleShowAlert = () => {
        window.alert('Đang cập nhật!!!');
    };
    const handleNavigateToThanhToan = () => {
        navigate('/thanhtoan')
    }

    const handleNavigateToQuanLi = () => {
        navigate('/dashboard')
    }
    const signOut = () => {
        firebaseAuth
            .signOut()
            .then(() => {
                dispatch(setUserNull(null));
                navigate("/login", { replace: true })
            })
            .catch((err) => console.log(err));
    }
    const [isMenu, setIsMenu] = useState(false);

    return (
        <header className="fixed z-50 w-screen p-3 px-4 md:p-6 md:px-16 bg-primary">
            {/* desktop & tablet */}
            <div className="hidden md:flex w-full h-full items-center justify-between">
                <Link to={"/"} className="flex items-center gap-2">
                    <img src={Logo} className="w-32 object-cover" alt="logo" />
                    <p className="text-headingColor text-xl font-bold"></p>
                </Link>
                <div className="flex items-center gap-8">
                    <motion.ul
                        initial={{ opacity: 0, x: 200 }}
                        animate={{ opacity: 1, x: 0 }}
                        exit={{ opacity: 0, x: 200 }}
                        className="flex items-center gap-24 "
                    >
                        <NavLink to={"/"} className="text-lg text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer">
                            Trang chủ
                        </NavLink>
                        <NavLink to={"/"} className="text-lg text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer"
                        >
                            Menu
                        </NavLink>
                        <NavLink to={"/"} className="text-lg text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer"
                            onClick={handleShowAlert}
                        >
                            Thông tin liên hệ
                        </NavLink>
                        {(user && (user.role === "Staff" || user.role === "admin" || user.role === "moderator")) ? (
                            <>
                                <li
                                    className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                    onClick={() => {
                                        setIsMenu(false)
                                        handleNavigateToQuanLi()
                                    }}
                                >
                                    Trang quản lí
                                </li>
                                <li
                                    className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                    onClick={() => {
                                        setIsMenu(false)
                                        handleNavigateToThanhToan()
                                    }}
                                >
                                    Trang thanh toán
                                </li></>) : (<></>)}
                    </motion.ul>
                    <div
                        className="relative flex items-center justify-center cursor-pointer"
                        onClick={() => dispatch(openCart())}
                    >
                        <MdShoppingBasket id="ShoppingBasket" className="text-textColor text-2xl" />
                        {cartItems?.items && cartItems?.items.length > 0 && (
                            <div className="absolute -top-2 -right-2 w-5 h-5 rounded-full bg-cartNumBg flex items-center justify-center">
                                <p className="text-xs text-white font-semibold">
                                    {/* Calculate the total quantity of cart items */}
                                    {cartItems.items.reduce((totalQuantity, item) => totalQuantity + item.quantity, 0)}
                                </p>
                            </div>
                        )}
                    </div>

                    <div className="relative">
                        <motion.img
                            whileTap={{ scale: 0.6 }}
                            src={user ? user.picture : Avatar}
                            className="w-10 min-w-[40px] h-10 min-h-[40px] drop-shadow-xl cursor-pointer rounded-full"
                            alt="userprofile"
                            onClick={() => setIsMenu(!isMenu)}
                        />
                        {isMenu && (
                            <motion.div
                                initial={{ opacity: 0, scale: 0.6 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.6 }}
                                className="w-40 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
                            >
                                {user ? (<>
                                    <p
                                        className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                                        onClick={signOut}
                                    >
                                        Đăng xuất <MdLogout />
                                    </p>
                                </>
                                    // <Link to={"/createItem"}>
                                    /* <p
                                        className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                                        onClick={() => setIsMenu(false)}
                                    >
                                        New Item <MdAdd />
                                    </p> */
                                    // </Link>
                                ) : <>
                                    <NavLink to={"/login"}
                                        className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                                    >
                                        Đăng nhập <MdLogin />
                                    </NavLink>
                                </>}


                            </motion.div>
                        )}
                    </div>
                </div>
            </div>

            {/* mobile */}
            <div className="flex items-center justify-between md:hidden w-full h-full ">
                <div
                    className="relative flex items-center justify-center cursor-pointer"
                    onClick={() => dispatch(openCart())}
                >
                    <MdShoppingBasket className="text-textColor text-2xl" />
                    {cartItems?.items && cartItems?.items.length > 0 && (
                        <div className=" absolute -top-2 -right-2 w-5 h-5 rounded-full bg-cartNumBg flex items-center justify-center">
                            <p className="text-xs text-white font-semibold">
                                {cartItems.items.reduce((totalQuantity, item) => totalQuantity + item.quantity, 0)}
                            </p>
                        </div>
                    )}
                </div>
                <Link to={"/"} className="flex items-center gap-2">
                    <img src={Logo} className="w-32 object-cover" alt="logo" />
                    <p className="text-headingColor text-xl font-bold"></p>
                </Link>

                <div className="relative">
                    <motion.img
                        whileTap={{ scale: 0.6 }}
                        src={user?.picture ? user?.picture : Avatar}
                        className="w-10 min-w-[40px] h-10 min-h-[40px] drop-shadow-xl cursor-pointer rounded-full"
                        alt="userprofile"
                        onClick={() => setIsMenu(!isMenu)}
                    />
                    {isMenu && (
                        <motion.div
                            initial={{ opacity: 0, scale: 0.6 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.6 }}
                            className="w-40 bg-gray-50 shadow-xl rounded-lg flex flex-col absolute top-12 right-0"
                        >
                            {user && user.email === "quoccuong.ukh97@gmail.com" && (
                                <Link to={"/createItem"}>
                                    <p className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                                        onClick={() => setIsMenu(false)}
                                    >
                                        Sản phẩm mới <MdAdd />
                                    </p>
                                </Link>
                            )}

                            <ul className="flex flex-col ">
                                <li
                                    className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                    onClick={() => setIsMenu(false)}
                                >
                                    Trang Chủ
                                </li>
                                <li
                                    className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                    onClick={() => {
                                        handleGoToMenu();
                                        setIsMenu(false)
                                    }}
                                >
                                    Menu
                                </li>
                                <li
                                    className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                    onClick={() => {
                                        handleShowAlert();
                                        setIsMenu(false)
                                    }}
                                >
                                    Thông tin liên hệ
                                </li>
                                {(user && (user.role === "Staff" || user.role === "admin" || user.role === "moderator")) ? (

                                    <>
                                        <li
                                            className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                            onClick={() => {
                                                setIsMenu(false)
                                                handleNavigateToQuanLi()
                                            }}
                                        >
                                            Trang quản lí
                                        </li>
                                        <li
                                            className="text-base text-textColor hover:text-headingColor duration-100 transition-all ease-in-out cursor-pointer hover:bg-slate-100 px-4 py-2"
                                            onClick={() => {
                                                setIsMenu(false)
                                                handleNavigateToThanhToan()
                                            }}
                                        >
                                            Trang thanh toán
                                        </li></>
                                ) : <></>}
                            </ul>
                            {user ? (
                                < p
                                    className="m-2 p-2 rounded-md shadow-md flex items-center justify-center bg-gray-200 gap-3 cursor-pointer hover:bg-gray-300 transition-all duration-100 ease-in-out text-textColor text-base"
                                    onClick={signOut}
                                >
                                    Đăng xuất <MdLogout />
                                </p>
                            )

                                : (<NavLink to={"/login"}
                                    className="px-4 py-2 flex items-center gap-3 cursor-pointer hover:bg-slate-100 transition-all duration-100 ease-in-out text-textColor text-base"
                                >
                                    Đăng nhập <MdLogin />
                                </NavLink>)}

                        </motion.div>
                    )}
                </div>
            </div>
            {isCartOpen && <CartContainer />}
        </header >
    );
};

export default Header;
